import { motion } from "framer-motion";

export function SectionHeading({ index, eyebrow, title, right }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className="mb-8 flex flex-wrap items-end justify-between gap-4"
    >
      <div>
        <p className="mb-2 font-score text-xs tracking-[0.3em] text-volt">
          {index && <span className="mr-3 text-slate-600">{index}</span>}
          {eyebrow}
        </p>
        <h2 className="font-display text-3xl uppercase tracking-tight text-white sm:text-4xl lg:text-5xl">{title}</h2>
      </div>
      {right}
    </motion.div>
  );
}

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.55, delay, ease: [0.16, 1, 0.3, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
